import { render, staticRenderFns } from "./ManualCancelServer.vue?vue&type=template&id=4d68aa48&scoped=true"
import script from "./ManualCancelServer.vue?vue&type=script&lang=js"
export * from "./ManualCancelServer.vue?vue&type=script&lang=js"
import style0 from "./ManualCancelServer.vue?vue&type=style&index=0&id=4d68aa48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d68aa48",
  null
  
)

export default component.exports